import type * as Types from '../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import { FileFieldsFragmentDoc } from '../../graphql/gql-fragments/document.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlUpdateFileMutationVariables = Types.Exact<{
  input: Types.GqlUpdateFileInput;
  companyId: Types.Scalars['ID']['input'];
}>;


export type GqlUpdateFileMutation = { updateFile: { id: string, companyId: string, mimeType: string, filename: string, filesize?: number | null, sha256?: string | null, signedFilesize?: number | null, signedSha256?: string | null, signatureMethod?: Types.GqlDocumentSignatureMethod | null, dirty: boolean, scriveMtime?: string | null, scriveCtime?: string | null, scriveStatus?: Types.GqlScriveDocumentStatus | null, scriveParties?: any | null, scriveTimeoutTime?: string | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, signAllowedAction: Types.GqlSignAllowedAction, hasSignStatus: boolean, hasThumbnail: boolean, kind: Types.GqlDocSystemTagKind, groupId?: string | null, userTags?: Array<string> | null, genState: Types.GqlDocGenState, uploaded: boolean, reminderSentAt?: string | null, deletable: boolean, softDeletable: boolean, createdAt: string, updatedAt: string, sharedWithShareholders: boolean } };


export const UpdateFileDocument = gql`
    mutation UpdateFile($input: UpdateFileInput!, $companyId: ID!) {
  updateFile(input: $input, companyId: $companyId) {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export type GqlUpdateFileMutationFn = Apollo.MutationFunction<GqlUpdateFileMutation, GqlUpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<GqlUpdateFileMutation, GqlUpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GqlUpdateFileMutation, GqlUpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<GqlUpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<GqlUpdateFileMutation, GqlUpdateFileMutationVariables>;